<template>
  <layout-basic>
      <h3 class="title is-4">Export</h3>

      <form v-on:submit="exportFormSubmit">
        <section>
          <b-field>
            <b-checkbox v-model="exportForm.exportProjects">
              Export projects
            </b-checkbox>
          </b-field>
        </section>

        <section v-if="exportForm.exportProjects" class="ml-5">
          <b-field v-for="project of projects">
            <b-checkbox v-model="exportForm.projects[project._id]">
              {{project.name}}
            </b-checkbox>

            <div v-if="exportForm.projects[project._id]" class="ml-5">
              <b-checkbox v-model="exportForm.exportIncludeTestResultForProjects[project._id]" size="is-small">
                Include the test results
              </b-checkbox>
            </div>
          </b-field>
        </section>

        <section>
          <b-field>
            <b-checkbox v-model="exportForm.exportTestTypes">
              Export test types
            </b-checkbox>
          </b-field>
        </section>

        <section v-if="exportForm.exportTestTypes" class="ml-5">
          <b-field v-for="testType of testTypes">
            <b-checkbox v-model="exportForm.testTypes[testType._id]">
              {{testType.name}}
            </b-checkbox>
          </b-field>
        </section>

        <br><br>

        <button class="button is-primary">Export</button>
      </form>

    <a id="downloadAnchorElem"></a>
  </layout-basic>

</template>
<script>

import LayoutBasic from '@/layouts/LayoutBasic'
import ProjectService from '@/services/ProjectService'
import SystemService from '@/services/SystemService'
import TestTypeService from "@/services/TestTypeService";

export default {
  name: 'Projects',
  components: {
    LayoutBasic
  },
  created () {
    this.getProjectList();
    this.getTestTypes();
  },
  data () {
    return {
      exportForm: {
        exportProjects: false,
        exportTestTypes: false,
        exportIncludeTestResultForProjects: {},
        projects: {},
        testTypes: {}
      },
      projects: [],
      testTypes: [],
    }
  },

  methods: {
    getExportConfig()
    {
      let config = {
        'projects': [],
        'testTypes': []
      }

      if (this.exportForm.exportProjects === true) {
        for (let projectId in this.exportForm.projects) {
          if (this.exportForm.projects[projectId]) {
            config.projects.push({
              id: projectId,
              includeTestResults: this.exportForm.exportIncludeTestResultForProjects.hasOwnProperty(projectId) && this.exportForm.exportIncludeTestResultForProjects[projectId] === true
            });
          }
        }
      }

      if (this.exportForm.exportTestTypes === true) {
        for (let testTypeId in this.exportForm.testTypes) {
          if (this.exportForm.testTypes[testTypeId]) {
            config.testTypes.push({
              id: testTypeId
            });
          }
        }
      }

      console.log(config);

      return config
    },

    getProjectList() {
      ProjectService.getList().then((response) => {
        this.projects = response.data;
      }).catch((e) => {
        console.log(e);
      })
    },

    getTestTypes() {
      TestTypeService.getList()
        .then(response => {
          this.testTypes = response.data
        })
    },

    exportFormSubmit(e) {
      const exportConfig = this.getExportConfig();
      SystemService.export(exportConfig).then(response => {
        this.downloadJson(response.data);
      })
      e.preventDefault();
    },

    downloadJson(data) {
      const dataStr = "data:text/json;charset=utf-8," + encodeURIComponent(JSON.stringify(data));
      const dlAnchorElem = document.getElementById('downloadAnchorElem');
      dlAnchorElem.setAttribute("href",     dataStr     );
      dlAnchorElem.setAttribute("download", "cloddog-export-" + Date.now() +".json");
      dlAnchorElem.click();
    }
  }
}
</script>
